import {
  CategorizedOptions, Formblock, Popover, Textfield,
} from '@zolteam/zol-admin-ui';
import { useMemo, useRef, useState } from 'react';
// services
import { useGetAirports } from '../../../services/airports/airportsQueries';
// style
import style from './AutcompleteAirport.module.css';
// utils
import { getAirportLabel } from '../../../domain/airports/airportUseCases';

/**
 * AutocompleteAirports component.
 * @param {object} props
 * @param {Function} props.setAirport
 * @param {string} props.label
 * @param {string} props.name
 * @param {{value: string, label: string}} [props.value]
 * @param {string} [props.errorMessage]
 * @param {Function} [props.onBlur]
 * @returns {JSX.Element}
 */
function AutocompleteAirports({
  setAirport, value, label, errorMessage = null, name, onBlur,
}) {
  const inputElRef = useRef(null);
  const [search, setSearch] = useState(null);
  const { data: airports } = useGetAirports({
    search,
    pageNumber: 1,
    pageSize: 10,
  }, {});

  const airportOptions = useMemo(() => ([{
    label,
    options: airports?.data?.map(
    /**
     * @param {Airport} airport
     * @returns {{ label: string, value: string }}
     */
      (airport) => ({ label: getAirportLabel(airport.code, airport.city), value: airport.code }),
    ) || [],
  }]), [airports]);

  // handlers

  /**
   * Handle the search bar change.
   * @param {import('react').BaseSyntheticEvent} e
   * @returns {void}
   */
  const handleSetSearch = (e) => {
    setAirport(null);
    setSearch(e.target?.value);
  };

  /**
   * Handle the search bar click.
   * @param {string} code
   * @returns {void}
   */
  const handleSearchClick = (code) => {
    const selectedAirport = airportOptions?.[0]?.options?.find(({ value: val }) => val === code);
    setSearch(null);
    setAirport(selectedAirport);
  };

  // renderers
  const getPopoverContent = () => (
    <CategorizedOptions
      options={airportOptions}
      onSearchChange={null}
      emptyOptionListLabel="Aucun contenu"
      onItemClick={handleSearchClick}
    />
  );

  return (
    <Formblock
      key={name}
      htmlFor={name}
      label={label}
      message={errorMessage}
      className={style.wrapper}
      color={errorMessage ? 'error' : 'default'}
    >
      <Popover
        className={style.popover}
        handleClassName={style.popover}
        placement="bottom-start"
        content={getPopoverContent()}
        popoverBoxStyle={!search ? { visibility: 'hidden', display: 'none' } : { width: inputElRef?.current?.getBoundingClientRect()?.width }}
        triggerOnce
      >
        <Textfield
          hasError={!!errorMessage}
          ref={inputElRef}
          type="text"
          // @ts-ignore
          placeholder={label}
          name={name}
          value={search === null ? value?.label : search}
          onChange={handleSetSearch}
          onBlur={onBlur}
        />
      </Popover>
    </Formblock>
  );
}

export default AutocompleteAirports;
